<template lang="pug">
  extra-druck-vorlagen-render(v-if="druckVorlagen.length" :value="druckVorlagen[0]" :item="text" :bg="3" color="white" no-editor :border="false")

</template>

<script>
import ExtraDruckVorlagenRender from "./extras/extra-druck-vorlagen-render.vue"
import gql from 'graphql-tag'
import { sortBy } from 'lodash'

export default {
  components: {
    ExtraDruckVorlagenRender
  },
  props: {
    value: {
      type: String
    },
    projektId: {
      type: String
    }
  },
  data () {
    return {
      currentUser: null,
      druckVorlagen: []
    }
  },
  apollo: {
    druckVorlagen: {
      query: gql`query MeineVisitenkarteVueDruckVorlagen {
        druckVorlagen(where: { slug: "hvd_visitenkarte" }) {
          id
          name
          slug
          pages {
            backgroundName
            backgroundUrl
            format
            height
            width
            texts {
              x
              y
              width
              height
              size
              lineHeight
              type
              text
              template
              options
            }
          }
        }
      }`
    },
    currentUser: {
      query: gql`query MeineVisitenkarteVue {
        currentUser {
          id
          person {
            id
            email
            titel
            pronouns
            anrede
            vorname
            nachname
            funktion
            telefon
            fax
            mobil
            personenProjekte {
              id
              signaturDefault
              signaturFunktion
              signaturInfofeld
              signaturSocialMedia1
              signaturSocialMedia2
              signaturSocialMedia3
              signaturWebsite
              signaturZeigeMobil
              signaturZeigeProjektEmail
              signaturZeigeTelefon
              signaturZeigeTitel
              signaturZeigePronouns
              signaturWerbebildUseDefault
              signaturWerbebild(size: "x100")
              signaturZusatzlogo(size: "x100")
              projekt {
                id
                logo(size: "100x100")
                fax
                telefon
                name
                email
                website
                standort {
                  ort
                  plz
                  strasse
                  hausnummer
                }
              }
            }
          }
        }
      }`,
    }
  },
  computed: {
    text() {
      const person = this.currentUser && this.currentUser.person
      let personenProjekt
      if (this.projektId) {
        personenProjekt = person && person.personenProjekte && person.personenProjekte.find(pp => pp.projekt.id == this.projektId)
      }
      if (!personenProjekt) {
        personenProjekt = person && person.personenProjekte && sortBy(person.personenProjekte, 'projekt.id')[0]
      }
      const projekt = personenProjekt && personenProjekt.projekt
      const standort = projekt && projekt.standort
      if (standort) {
        return { ...personenProjekt, ...person, projekt: projekt, addr: standort }
      } else if (this.currentUser) {
        return { vorname: 'Konnte eintrag in der Telefonliste nicht finden.', nachname: '' }
      } else {
        return { vorname: 'Einloggen um Vorschau zu sehen.', nachname: '' }
      }
    }
  }
}
</script>
